/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import {
    Card,
    Table,
    Stack,
    Paper,
    Avatar,
    Button,
    Container,
    Typography,
    IconButton,
    TableContainer,
    TablePagination,
    ListItemIcon,
    Box,
    TextField,
    Tooltip,
    Switch,
    Grid,
    Divider,

} from '@mui/material';

import dayjs from 'dayjs';
import CardContent from '@mui/material/CardContent';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CardActions from '@mui/material/CardActions';
import Iconify from '../../components/iconify';
// import { apiUrl } from '../../utils/api';
import { apiUrl, } from '../../utils/api';
import { useNavigate, useParams } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { LogoUpdate } from './components/LogoUpdate';
import { useGetStoreTimeApiMutation, useGetStoreOpenMutation, useGetStoreTimeUpdateApiMutation } from '../../redux/services/seller/storeTime';
import { useForm, Controller } from 'react-hook-form';
import { showError, showSuccess } from '../../utils/toast';
import { getStore, setStore, } from '../../utils/session';
import UpdateStoreTime from './components/UpdateStoreTime';

const DataLogo = ({ name, path }) => {
    const url = `${apiUrl.Logo}${path}`;
    return (
        <Avatar alt={name} src={url} sx={{ width: 70, height: 70 }} />

    )
}
const SellerSideNav = ({ seller, load }) => {
    const { control, handleSubmit, getValues, setValue } = useForm();
    // eslint-disable-next-line no-unneeded-ternary
    const storeIntioal = getStore()

    // const [value, setValue] = useState('12:04');
    const [isStoreOpen, setIsStoreOpen] = useState(storeIntioal);
    const [time, setTime] = useState();
    const [checked, setChecked] = useState()
    const [dayCheck, setDayCheck] = useState({
        mon: true,
        tue: true,
        wed: true,
        thr: true,
        fri: true,
        sat: true,
        sun: true,
    });
    const [updateStoreTimeData, setUpdateStoreTimeData] = useState(null)
    const [logo, setLogo] = useState(null)

    // Redux api call
    const [getStoreTime, GetStoreTime] = useGetStoreTimeApiMutation()
    const [getStoreOpen, GetstoreOpen] = useGetStoreOpenMutation()
    const [getUpdateTime, UpdateTime] = useGetStoreTimeUpdateApiMutation()




    const onhandelUpdateTime = (seller) => {
        setUpdateStoreTimeData(seller)
        console.log("storeTime", updateStoreTimeData)
    }


    const { id } = useParams();

    // onStoreOpen
    const onStoreOpen = async () => {
        const body = {
            seller_id: id,
            open: !isStoreOpen
        }
        try {
            const storeData = await getStoreOpen(body)
            setIsStoreOpen(storeData.data.timing.store_open);


        } catch (error) {
            console.log("error", error)
        }
    }


    useEffect(() => {
        if (GetstoreOpen.isSuccess) {
            if (!isStoreOpen) {
                showSuccess("Store Open ");
            } else {
                showSuccess("Store Close ");
            }
            GetstoreOpen.reset()
        }
        if (GetstoreOpen.isError) {
            showError(GetstoreOpen.error.data.msg)
            GetstoreOpen.reset()

        }
    }, [GetstoreOpen]);

    useEffect(() => {
        setStore(isStoreOpen)
    }, [isStoreOpen]);

    // stotetime
    const storeTimeData = async () => {
        const body = {
            'seller_id': id,
        }
        try {
            const storeData = await getStoreTime(body)
            setTime(storeData.data.timing)
            console.log("storeTime", storeData.data.timing)


        } catch (error) {
            console.log("error", error)
        }
    }


    useEffect(() => {
        storeTimeData()

    }, [time]);



    const handleSwitchStoreDayChange = (day) => {

        const updatedTiming = { ...time };
        updatedTiming[day] = !updatedTiming[day];
        setTime(updatedTiming);

    };


    // storeTime Update
    useEffect(() => {
        const daysOfWeek = ["mon", "tue", "wed", "thr", "fri", "sat", "sun"];

        daysOfWeek.forEach((day) => {
            setValue(day, seller?.timing?.[day]);
            setValue(`${day}_open`, seller?.timing?.[`${day}_open`]);
            setValue(`${day}_close`, seller?.timing?.[`${day}_close`]);
        });

        // setValue("mon", seller?.timing?.mon)
        // setValue("mon_open", seller?.timing?.mon_open)
        // setValue("mon_close", seller?.timing?.mon_close)
        // setValue("tue", seller?.timing?.tue)
        // setValue("tue_open", seller?.timing?.tue_open)
        // setValue("tue_close", seller?.timing?.tue_close)
        // setValue("wed", seller?.timing?.wed)
        // setValue("wed_open", seller?.timing?.wed_open)
        // setValue("wed_close", seller?.timing?.wed_close)
        // setValue("thr", seller?.timing?.thr)
        // setValue("thr_open", seller?.timing?.thr_open)
        // setValue("thr_close", seller?.timing?.thr_close)
        // setValue("fri", seller?.timing?.fri)
        // setValue("fri_open", seller?.timing?.fri_open)
        // setValue("fri_close", seller?.timing?.fri_close)
        // setValue("sat", seller?.timing?.sat)
        // setValue("sat_open", seller?.timing?.sat_open)
        // setValue("sat_close", seller?.timing?.sat_close)
        // setValue("sun", seller?.timing?.sun)
        // setValue("sun_open", seller?.timing?.sun_open)
        // setValue("sun_close", seller?.timing?.sun_close)

    }, [seller])

    const onUpdateStoreTime = async (data) => {
        const body = {
            seller_id: seller.id,
            mon: dayCheck.mon,
            mon_open: data.mon_open,
            mon_close: data.mon_close,
            tue: dayCheck.tue,
            tue_open: data.tue_open,
            tue_close: data.tue_close,
            wed: dayCheck.wed,
            wed_open: data.wed_open,
            wed_close: data.wed_close,
            thr: dayCheck.thr,
            thr_open: data.thr_open,
            thr_close: data.thr_close,
            fri: dayCheck.fri,
            fri_open: data.fri_open,
            fri_close: data.fri_close,
            sat: dayCheck.sat,
            sat_open: data.sat_open,
            sat_close: data.sat_close,
            sun: dayCheck.sun,
            sun_open: data.sun_open,
            sun_close: data.sun_close

        };
        try {
            const uptateTimedata = await getUpdateTime(body)
            console.log("storetime", uptateTimedata)
            setUpdateStoreTimeData(null)
            load()

        } catch (error) {
            console.log("error", error)
        }
    };

    useEffect(() => {
        if (UpdateTime.isSuccess) {
            showSuccess("Updated Time ");
            UpdateTime.reset()
        }
        if (UpdateTime.isError) {
            showError(UpdateTime.error.data.msg)
            UpdateTime.reset()

        }
    }, [UpdateTime]);

    const handleDayValueChange = (day) => {
        setDayCheck((prevValues) => ({
            ...prevValues,
            [day]: !prevValues[day],
        }));
    };



    const storeTimeInputFields = (day) => {
        if (time) {
            return (
                <>
                    <Stack direction='row' spacing={2} >
                        <Switch
                            checked={time[`${day}`]}
                            onChange={() => handleSwitchStoreDayChange(day)}
                            color="primary"
                        />
                        <Typography variant='h6'>{time[`${day}`] ? `${day} is open` : `${day} is closed`}</Typography>
                    </Stack>

                    <Stack direction='row' spacing={1}>
                        <TextField
                            size='small'
                            type='time'
                            id={`${day}_open`}
                            name={`${day}_open`}
                            value={time[`${day}_open`]}
                            InputProps={{ readOnly: true }}
                        />
                        <TextField
                            size='small'
                            type='time'
                            id={`${day}_close`}
                            name={`${day}_close`}
                            value={time[`${day}_close`]}
                            InputProps={{ readOnly: true }}
                        />
                        <br />
                    </Stack>
                </>
            );
        }
        return null;
    };

    return (
        <>
            <Box
                mt={1}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Card sx={{ boxShadow: 1, m: 1, width: "600px", height: "100%", }} >
                    <CardContent>
                        <Stack direction={'row'}>
                            <Button variant='text'><DataLogo path={seller?.logo} /></Button>
                            <Button variant="text" mt={3} onClick={() => { setLogo(seller) }}>
                                {seller?.business_name}
                            </Button>
                        </Stack>
                        <Typography variant="body" mt={2} >
                            <Iconify icon="icon-park-solid:edit-name" width={24} height={24} color="blue" />
                            <span style={{ fontSize: "15px", color: "gray" }}>Name</span>
                        </Typography>
                        <Typography variant="h6" sx={{ fontFamily: 'sans-serif', }} >
                            {seller?.business_name}
                        </Typography>
                        <hr />
                        <Typography variant="h6"  >
                            <Iconify icon="mdi:address-marker-outline" width={20} height={20} color="red" />
                            <span style={{ fontSize: "15px", color: "gray" }}>Address</span>
                        </Typography>
                        <Typography variant="h6" sx={{ fontFamily: 'sans-serif' }} >
                            {seller?.address}
                        </Typography>
                        <hr />

                        <Typography variant="h6"  >
                            <Iconify icon="bxs:landmark" width={20} height={20} color="gray" />
                            <span style={{ fontSize: "15px", color: "gray" }}>Landmark</span>
                        </Typography>
                        <Typography variant="h6" sx={{ fontFamily: 'sans-serif' }} >
                            {seller?.landmark}
                        </Typography>
                        <hr />
                        <Typography variant="h6"  >
                            <Iconify icon="mdi:home-city-outline" width={20} height={20} color="green" />

                            <span style={{ fontSize: "15px", color: "gray" }}>city</span>
                        </Typography>
                        <Typography variant="h6" sx={{ fontFamily: 'sans-serif' }} >
                            {seller?.city.name}
                        </Typography>
                        <hr />
                        <Typography variant="h6"  >
                            <Iconify icon="ic:outline-qr-code-2" width={20} height={20} color="black" />
                            <span style={{ fontSize: "15px", color: "gray" }}>Pincode</span>
                        </Typography>
                        <Typography variant="h6" sx={{ fontFamily: 'sans-sans-serif' }} >
                            {seller?.pincode}
                        </Typography>
                        <hr />

                        <LogoUpdate sellerLogo={logo} sellerid={seller} setSellerLogo={setLogo} setload={load} />

                    </CardContent >
                </Card >
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Card sx={{ boxShadow: 1, m: 1, }} >
                    <CardContent>
                        <Box>
                            <Typography variant='h5' textAlign="center">Store Time</Typography>
                            <Divider />
                            <Box mb={2} mt={3} >
                                <Stack direction='row' spacing={2} >
                                    <Typography variant='h6' > {isStoreOpen ? "Store-Open " : "Store-close"}  </Typography>
                                    <Switch
                                        checked={isStoreOpen}
                                        onChange={onStoreOpen}
                                    />
                                </Stack>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>

                                        <Box mb={2}>
                                            <Stack direction='column' spacing={2}>
                                                <Typography variant="subtitle2" color='gray' fontSize='18px'  >
                                                    Monday
                                                </Typography>
                                            </Stack>
                                            <Stack direction='column' >
                                                {storeTimeInputFields('mon')}
                                            </Stack>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box mb={2}>
                                            <Stack direction='column' spacing={2}>
                                                <Typography variant="subtitle2" color='gray' fontSize='18px'  >
                                                    Tuesday
                                                </Typography>
                                            </Stack>
                                            <Stack direction='column' >
                                                {storeTimeInputFields('tue')}
                                            </Stack>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box mb={2}>
                                            <Stack direction='column' spacing={2}>
                                                <Typography variant="subtitle2" color='gray' fontSize='18px'  >
                                                    Wednesday
                                                </Typography>
                                            </Stack>
                                            <Stack direction='column' >
                                                {storeTimeInputFields('wed')}
                                            </Stack>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box mb={2}>
                                            <Stack direction='column' spacing={2}>
                                                <Typography variant="subtitle2" color='gray' fontSize='18px'  >
                                                    Thursday
                                                </Typography>
                                            </Stack>
                                            <Stack direction='column' >
                                                {storeTimeInputFields('thr')}
                                            </Stack>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box mb={2}>
                                            <Stack direction='column' spacing={2}>
                                                <Typography variant="subtitle2" color='gray' fontSize='18px'  >
                                                    Friday
                                                </Typography>
                                            </Stack>
                                            <Stack direction='column' >
                                                {storeTimeInputFields('fri')}
                                            </Stack>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box mb={2}>
                                            <Stack direction='column' spacing={2}>
                                                <Typography variant="subtitle2" color='gray' fontSize='18px'  >
                                                    Saturday
                                                </Typography>
                                            </Stack>
                                            <Stack direction='column' >
                                                {storeTimeInputFields('sat')}
                                            </Stack>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box mb={2}>
                                            <Stack direction='column' spacing={2}>
                                                <Typography variant="subtitle2" color='gray' fontSize='18px'  >
                                                    Sunday
                                                </Typography>
                                            </Stack>
                                            <Stack direction='column' >
                                                {storeTimeInputFields('sun')}
                                            </Stack>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                    <Button variant='contained' onClick={() => { onhandelUpdateTime(seller) }} >Update Store Taming</Button>
                                </Box>

                            </Box>
                        </Box>
                    </CardContent>

                </Card>
            </Box>
            <Dialog
                open={updateStoreTimeData != null}
                onClose={() => { setUpdateStoreTimeData(null) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ textAlign: "center", fontFamily: 'inherit' }}>
                    <Typography variant='h3' >Store time</Typography>
                    <hr />
                </DialogTitle>
                <form onSubmit={handleSubmit(onUpdateStoreTime)}>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">

                            <Grid container spacing={1}>
                                <Container maxWidth='md'>
                                    {['mon', 'tue', 'wed', 'thr', 'fri', 'sat', 'sun'].map((day) => (
                                        <Grid item xs={12} key={day}>
                                            <Box mb={2}>
                                                <Stack direction='column' spacing={2}>
                                                    <Typography variant='body' color='gray' fontSize='18px'>
                                                        {day.charAt(0).toUpperCase() + day.slice(1)}
                                                    </Typography>
                                                </Stack>
                                                <Stack direction='row' spacing={2} >
                                                    <Switch
                                                        checked={dayCheck[`${day}`]}
                                                        onChange={() => handleDayValueChange(day)}
                                                        color="primary"
                                                    />
                                                    <Typography variant='h6'>{dayCheck[`${day}`] ? `${day} is open` : `${day} is closed`}</Typography>
                                                </Stack>
                                                <Stack direction='row' spacing={2}>
                                                    <Controller
                                                        name={`${day}_open`}
                                                        control={control}
                                                        render={({ field }) => (
                                                            <TextField
                                                                size='small'
                                                                type="time"
                                                                {...field}
                                                                variant="outlined"
                                                            />
                                                        )}
                                                    />
                                                    <br />
                                                    <Controller
                                                        name={`${day}_close`}
                                                        control={control}
                                                        render={({ field }) => (
                                                            <TextField
                                                                size='small'
                                                                type="time"
                                                                {...field}
                                                                variant="outlined"
                                                            />
                                                        )}
                                                    />
                                                </Stack>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Container>
                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button type='submit'>Update</Button>
                        <Button onClick={() => { setUpdateStoreTimeData(null) }}>Close</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    )
}

export default SellerSideNav
